export enum Visibility {
	INVALID = "INVALID",
	INVISIBLE = "INVISIBLE",
	VISIBLE = "VISIBLE",
}
